import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { useAuth } from '@/contexts/AuthContext';
import { BalanceLiveTab } from '@/components/Pages/Balances/BalanceLiveTab';

export const Route = createFileRoute('/_protected/balances/')({
  component: RouteComponent,
  head: () => pageTitle('Balance financiero'),
});

function RouteComponent() {
  const { hasClaim, isLoading: authLoading } = useAuth();
  const canRead = hasClaim('BALANCES_READ');

  if (!authLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return <BalanceLiveTab />;
}
